"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addReadWriteRecipient_1 = require("./addReadWriteRecipient");
var resolveAllUnresolvedRecipients_1 = require("./resolveAllUnresolvedRecipients");
var isValidEmailAddress_1 = require("../utils/isValidEmailAddress");
var parseSuspectedDisplayNameEmailAddress_1 = require("../utils/parseSuspectedDisplayNameEmailAddress");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('parsePastedTextForRecipients')(function parsePastedTextForRecipients(recipientWell, inputText) {
    var recipientList = inputText.split(';');
    recipientList.forEach(function (element) {
        var trimmedElement = element.trim();
        if (trimmedElement.length > 0) {
            // try to parse out a suspected name + email address combo
            var result = parseSuspectedDisplayNameEmailAddress_1.default(trimmedElement);
            addReadWriteRecipient_1.default(recipientWell, isValidEmailAddress_1.default(result.EmailAddress.EmailAddress), result);
        }
    });
    resolveAllUnresolvedRecipients_1.default(recipientWell);
});
//# sourceMappingURL=parsePastedTextForRecipients.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/parsePastedTextForRecipients.js
// module id = 3396
// module chunks = 2 3